const langPack ={
    "en": {
        1: "Welcome to Tenzies!",
        2: "Select gamemode",
        3: "Simple",
        4: "Classic",
        5: "Back",
        6: "Match dices to win",
        7: "Start without saving",
        8: "Level",
        9: "Next",
        10: "Try again",
        11: "New game",
        12: "Go!",
        13: "Roll until all dice are the same. Click each die to freeze it at its current value between rolls.",
        14: "Roll",
        15: "Sign in",
        16: "Sign in if you want to save your progress",
        17: "Start",
        18: "Sign in",
        19: "Email",
        20: "Password",
        21: "Don't have an account?",
        22: "Sign up",
        23: "Create an account",
        24: "Repeat password",
        25: "Create",
        26: "Already have an account?",
        27: "Signed in as",
        28: "Sign out",
        29: "You are signed out",
        30: "or",
        31: "Welcome",
    },
    "ru": {
        1: "Приветствуем в Tenzies!",
        2: "Выберите режим",
        3: "Обычный",
        4: "Классика",
        5: "Назад",
        6: "Для победы нажимайте на одинаковые кубики",
        7: "Начать без сохранения",
        8: "Уровень",
        9: "Далее",
        10: "Попробовать снова",
        11: "Новая игра",
        12: "Вперед!",
        13: "Бросайте до тех пор, пока все кубики не станут одинаковыми. Нажмите на кубик, чтобы заморозить его текущее значение между бросками.",
        14: "Бросить",
        15: "Войти",
        16: "Авторизуйтесь, если хотите сохранить свой прогресс",
        17: "Начать",
        18: "Войти в аккаунт",
        19: "Эл. почта",
        20: "Пароль",
        21: "Нет аккаунта?",
        22: "Зарегистрироваться",
        23: "Создать аккаунт",
        24: "Повторите пароль",
        25: "Создать",
        26: "Уже есть аккаунт?",
        27: "Вы вошли как",
        28: "Выйти",
        29: "Вы вышли из аккаунта",
        30: "или",
        31: "Добро пожаловать"
    }
}

export default langPack